import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgPenaltyMissDimension = {
  height: 20,
  width: 20,
  viewBox: '0 0 16 16',
};

export const SvgPenaltyMiss = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      {/* White circle with red border */}
      <path
        fill="#fff"
        stroke="#EB1701"
        strokeWidth={1}
        d="M8 .5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z"
      />
      {/* Red cross centered */}
      <path
        fill="#EB1701"
        d="M10.828 5.98 8.808 8l2.02 2.02a.573.573 0 0 1 0 .808.573.573 0 0 1-.808 0L8 8.808l-2.021 2.021a.573.573 0 0 1-.808 0 .573.573 0 0 1 0-.808L7.192 8 5.171 5.98a.573.573 0 0 1 0-.808.573.573 0 0 1 .808 0L8 7.192l2.02-2.021a.573.573 0 0 1 .808 0 .573.573 0 0 1 0 .808Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
));
